import { useEffect } from 'react';
import { init } from '@cmctechnology/webinvest-analytics/dist/js/analytics';
import { createConfig } from '../configuration/configuration';

let analyticsInitialization: ReturnType<typeof init> | undefined;

const createPackageAnalyticsConfig = () => {
  const { analytics } = createConfig();

  return {
    ...analytics,
    mParticle: {
      ...analytics.mParticle,
      // BigScript is the sole mParticle runtime in the browser.
      isEnabled: false
    }
  };
};

export const initializeAnalyticsPackage = () => {
  const config = createPackageAnalyticsConfig();
  // With no plugins the package's ready callback can be missed entirely.
  if (!config.fullStory.isEnabled) return Promise.resolve(undefined);

  if (!analyticsInitialization) {
    analyticsInitialization = init(config).catch((error) => {
      analyticsInitialization = undefined;
      throw error;
    });
  }

  return analyticsInitialization;
};

export const useAnalyticsInit = (onInitialized?: () => void) => {
  useEffect(() => {
    let isMounted = true;

    initializeAnalyticsPackage()
      .then(() => {
        if (isMounted) onInitialized?.();
        return undefined;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });

    return () => {
      isMounted = false;
    };
  }, [onInitialized]);
};
